import { render, staticRenderFns } from "./phonenumber-input.pug?vue&type=template&id=5a6f39b6&lang=pug&"
import script from "./phonenumber-input.js?vue&type=script&lang=js&"
export * from "./phonenumber-input.js?vue&type=script&lang=js&"
import style0 from "./phonenumber-input.css?vue&type=style&index=0&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports